package com.essntl.features.organization.ui.organizationdetails.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import com.essntl.features.organization.ui.organizationdetails.OrganizationDetailsNavigation
import com.essntl.features.organization.ui.organizationdetails.OrganizationDetailsState
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlin.collections.orEmpty

@Composable
fun ContactListColumn(
    state: OrganizationDetailsState,
    onNavigation: (OrganizationDetailsNavigation) -> Unit,
    modifier: Modifier = Modifier,
) {
    val lazyListState = rememberLazyListState()

    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .fillMaxSize()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(vertical = EsConstants.SectionVerticalPadding),
    ) {
        if (state.getAllContacts.isLoading ||
            state.getAllContacts.data == null
        ) EsSpinner()
        else if (state.getAllContacts.isFailure)
            Text(
                text = "Something goes wrong!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
                textAlign = TextAlign.Center,
            )
        else if (state.getAllContacts.data.orEmpty().isEmpty())
            Text(
                text = "No contacts Found!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
                textAlign = TextAlign.Center,
            )
        else
            LazyColumn(
                horizontalAlignment = Alignment.CenterHorizontally,
                state = lazyListState,
                contentPadding = PaddingValues(vertical = EsConstants.SectionVerticalPadding),
                modifier = Modifier
                    .fillMaxSize()
                    .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
            ) {
                itemsIndexed(state.getAllContacts.data.orEmpty(), key = { _, r -> r.id }) { index, contact ->
                    val isSelected = rememberEquals(contact.id, setOf(state.selectedContactId)) { it }

                    SelectionContainer {
                        ContactItem(
                            contact = contact,
                            isSelected = isSelected,
                            onNavigation = onNavigation,
                            showDivider = index != state.getAllContacts.data.orEmpty().lastIndex,
                            modifier = Modifier
                                .padding(
                                    horizontal = EsConstants.SectionHorizontalPadding,
                                )
                                .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
                        )
                    }
                }
            }
    }
}